import {useToast} from '@/shared/components/toast/useToast';
import {useUserStore} from '@/stores/userStore';

// Debug aid: superadmins can visualize tracked license events (license_intent and
// license_action) as toasts by setting this sessionStorage key to 'true'
// (non-persistent, cleared when the browser session ends).
export const LICENSE_EVENT_VISUALIZATION_KEY = 'visualizeLicenseEvents';

export function isLicenseEventVisualizationEnabled(): boolean {
    return window.sessionStorage.getItem(LICENSE_EVENT_VISUALIZATION_KEY) === 'true';
}

export function setLicenseEventVisualizationEnabled(enabled: boolean): void {
    if (enabled) {
        window.sessionStorage.setItem(LICENSE_EVENT_VISUALIZATION_KEY, 'true');
    } else {
        window.sessionStorage.removeItem(LICENSE_EVENT_VISUALIZATION_KEY);
    }
}

export function visualizeTrackingEvent(summary: string, label: string): void {
    if (!isLicenseEventVisualizationEnabled() || !useUserStore().isSuperAdmin) {
        return;
    }

    useToast().success(summary, {detail: label, life: 10000});
}
